import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Subject } from 'rxjs';

const apiURL = environment.apiURL;

@Injectable({
  providedIn: 'root'
})
export class UserService {

  user = new Subject<any>();
  address = new Subject<any>();
  addresses = new Subject<any>();

  constructor(private http: HttpClient) { }

  setUser(data) {
    this.user.next(data);
  }

  setAddress(data) {
    this.address.next(data);
  }

  setAddresses(data) {
    this.addresses.next(data);
  }

  getUser() {
    return this.user.asObservable();
  }

  updateUser(data) {
    return this.http.put<{ success: boolean, data: any }>(`${apiURL}/users`, data);
  }

  getAddress() {
    return this.address.asObservable();
  }

  getAddresses() {
    return this.addresses.asObservable();
  }

  addAddress(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/users/address`, data);
  }

  updateAddress(data) {
    return this.http.put<{ success: boolean, data: any }>(`${apiURL}/users/address`, data);
  }

  deleteAddress(data) {
    return this.http.request<{ success: boolean, data: any }>('delete', `${apiURL}/users/address`, { body: data });
  }

  getUsersAdAdmin(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/users/query`, data);
  }

  addUserAdAdmin(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/users/many`, data);
  }

  getMe() {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/users/get`, {});
  }
}
